module.exports = __webpack_public_path__ + "img/icons_online_card.2d4809f3.svg";